import { lazy } from "react";

/**
 * Augments React.lazy with a page refresh if the component import fails.
 */
export const lazyWithReload = (componentImport: any) =>
  lazy(async () => {
    const pageHasAlreadyBeenForceRefreshed = JSON.parse(
      window.localStorage.getItem("lingo-lazy-refresh") || "false"
    );
    try {
      const component = await componentImport();
      window.localStorage.setItem("lingo-lazy-refresh", "false");
      return component;
    } catch (error) {
      if (!pageHasAlreadyBeenForceRefreshed) {
        // Assuming that the user is not on the latest version of the application.
        // Let's refresh the page immediately.
        window.localStorage.setItem("lingo-lazy-refresh", "true");
        return window.location.reload();
      }
      // The page has already been reloaded
      // Assuming that user is already using the latest version of the application.
      // Let's let the application crash and raise the error.
      throw error;
    }
  });
